import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    reportConfig: [],
};

const reportConfigSlice = createSlice({
    name: "reportConfig",
    initialState,
    reducers: {
        setReportConfig: (state, action) => {
            state.reportConfig = action.payload;
        },
    }
});

// 🟢 Exporting Actions
export const { setReportConfig } = reportConfigSlice.actions;

// 🔵 Selectors (Getters)
export const selectReportConfig = (state) => state.reportConfig.reportConfig;



// 🟣 Reducer Export
export default reportConfigSlice.reducer;
